import { ApiOutlined, RobotOutlined, CheckCircleFilled, BarChartOutlined, PartitionOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { PageHero, HeroChip } from '@/components/PageHero';
import { SectionCard } from '@/components/SectionCard';
import { ProvidersModelsSection } from './ProvidersModelsSection';
import { UsageSection } from './UsageSection';
import { FunctionModelSection } from './FunctionModelSection';
import { getAiProviders } from '@/api/aiProviders';
import { getAiModels } from '@/api/aiModels';
import { getAiTasks } from '@/api/aiTasks';

export function AiSettingsPage() {
  const providersQ = useQuery({ queryKey: ['ai-providers'], queryFn: getAiProviders });
  const modelsQ = useQuery({ queryKey: ['ai-models'], queryFn: getAiModels });
  const tasksQ = useQuery({ queryKey: ['ai-tasks'], queryFn: getAiTasks });

  const providers = providersQ.data ?? [];
  const keyed = providers.filter((p) => p.hasKey).length;
  const modelCount = modelsQ.data?.length ?? 0;
  const defaultModel = tasksQ.data?.default_model ?? null;
  const ready = keyed >= 1;

  return (
    <div style={{ maxWidth: 1000 }}>
      <PageHero
        icon={<RobotOutlined />}
        title="AI Settings"
        subtitle="Provider keys · models · used by AI translate and extract"
        chips={[
          <HeroChip key="models">Models {modelCount}</HeroChip>,
          <HeroChip key="default">Default {defaultModel ?? '— none —'}</HeroChip>,
          <HeroChip key="providers">Providers {keyed}/{providers.length || 4} keyed</HeroChip>,
          <HeroChip key="ready" tone={ready ? '#059669' : undefined}>
            {ready ? <><CheckCircleFilled /> Ready</> : 'No key yet'}
          </HeroChip>,
        ]}
      />

      <SectionCard
        tone="amber"
        icon={<BarChartOutlined />}
        title="Usage & Cost"
        desc="Tokens and spend across AI translate / extract."
      >
        <UsageSection />
      </SectionCard>

      <SectionCard
        tone="sky"
        icon={<PartitionOutlined />}
        title="Function → Model"
        desc="Default model + per-function overrides. Translate / extract use these automatically."
      >
        <FunctionModelSection />
      </SectionCard>

      <SectionCard
        tone="indigo"
        icon={<ApiOutlined />}
        title="Providers & Models"
        desc="API keys and models per provider — keys encrypted, never shown again."
      >
        <ProvidersModelsSection />
      </SectionCard>
    </div>
  );
}
